import { Link } from "react-router-dom";

import { StoreBadges } from "@/components/shared/StoreBadges";
import { LOGIN } from "@/routes";
import { trackMarketingCtaClick } from "@/services/marketingCtaAnalytics.service";

const TRACKING_ID = "blog-inline-v1";

export const BlogInlineCta = () => {
  const joinHref = LOGIN();

  return (
    <aside
      className="not-prose rounded-md border border-brand-500/40 bg-brand-500/[0.08] px-5 py-5 sm:px-6 sm:py-6"
      aria-label="Get Stasht"
      data-cta-id={TRACKING_ID}
    >
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between sm:gap-8">
        <div className="max-w-md">
          <p className="m-0 text-lg font-semibold text-foreground">Saves that work.</p>
          <p className="m-0 mt-1 text-sm leading-relaxed text-foreground/65">
            You save great stuff. We bring it back when it matters.
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:items-end">
          <Link
            to={joinHref}
            onClick={() =>
              trackMarketingCtaClick({
                destination: "signup_login",
                surface: "blog-inline",
                placement: "article_inline",
                label: "Join Stasht",
                href: joinHref,
                ctaId: TRACKING_ID,
              })
            }
            className="hidden text-sm font-semibold text-foreground underline decoration-foreground/30 underline-offset-4 transition-colors hover:text-brand-500 md:inline-flex"
          >
            Get started
          </Link>

          <div className="flex flex-wrap items-center gap-2" aria-label="Download Stasht">
            <StoreBadges
              className="h-9"
              surface="blog-inline"
              placement="article_inline"
              trackingId={TRACKING_ID}
            />
          </div>
        </div>
      </div>
    </aside>
  );
};
